(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taters-home"] && !Shopify.designMode) return;
  try {
    
function initWoodcrafts(){const root=document.querySelector('.tw-home');if(!root)return;const buttons=root.querySelectorAll('[data-tw-filter]');const cards=root.querySelectorAll('[data-tw-category]');function filter(category){if(![...buttons].some(b=>b.dataset.twFilter===category))category='all';let count=0;cards.forEach(card=>{card.hidden=category!=='all'&&card.dataset.twCategory!==category;if(!card.hidden)count++;});buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.twFilter===category)));root.querySelector('.tw-count').textContent=count+' / '+cards.length;};buttons.forEach(button=>button.addEventListener('click',()=>{filter(button.dataset.twFilter);const url=new URL(window.location);url.searchParams.set('category',button.dataset.twFilter);url.hash='tw-products';history.replaceState(null,'',url);}));filter(new URLSearchParams(window.location.search).get('category')||'all');}
initWoodcrafts();document.addEventListener('shopify:section:load',initWoodcrafts);

  } catch(e) { console.error(e); }
})();
})();
